import api from '../../../lib/api'
import type { PolicyResponse, RenewalPipelineLead } from '../../../types'

export interface PolicyFieldOverride {
  field: string
  extracted_value: string
  submitted_value: string
}

export interface PolicyExtractionResult {
  policy_number: string | null
  insurance_company: string | null
  premium_amount: number | null
  od_discount_percentage: number | null
  confidence: Record<string, number>
  extraction_failed: boolean
  extraction_error: string | null
}

export const policyService = {
  async issue(data: {
    lead_id: number
    policy_number: string
    insurance_company: string
    premium_amount: number
    od_discount_percentage: number
    payment_mode: 'CASH' | 'ONLINE' | 'CHEQUE' | 'UPI'
    payment_reference: string
    field_overrides?: PolicyFieldOverride[]
  }): Promise<PolicyResponse> {
    const res = await api.post('/policies/issue', data)
    return res.data
  },

  async extractPdf(leadId: number, file: File): Promise<PolicyExtractionResult> {
    const form = new FormData()
    form.append('file', file)
    const res = await api.post(`/policies/${leadId}/extract-pdf`, form, {
      headers: { 'Content-Type': undefined },
    })
    return res.data
  },

  async uploadPdf(leadId: number, file: File): Promise<{ valid: boolean; hash: string }> {
    const form = new FormData()
    form.append('file', file)
    const res = await api.post(`/policies/${leadId}/upload-policy`, form, {
      headers: { 'Content-Type': undefined },
    })
    return res.data
  },

  async getRenewalPipeline(days = 30): Promise<{ total: number; leads: RenewalPipelineLead[] }> {
    const res = await api.get('/policies/renewal-pipeline', { params: { days } })
    return res.data
  },
}
